export const useGetParams = () => {
  const searchParams = new URL(document.location).searchParams;
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',
    bg: searchParams.get('bg'),
    bgColor: searchParams.get('bgColor') || 'rgba(0,0,0,0.0)',

    title: getDefaultValue(
      searchParams.get('title'),
      'Choose your favorite\\n singer for today',
    ),
    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    qrTitle1: searchParams.get('qrTitle1'),
    qrTitle2: searchParams.get('qrTitle2'),
    sizeQR: searchParams.get('sizeQR') || '28.5',

    minFontWords: searchParams.get('minFontWords') || 35,
    maxFontWords: searchParams.get('maxFontWords') || 75,
    requestInterval:
      Number(searchParams.get('requestInterval') || 2000) || 2000,
    demo: searchParams.get('demo') || false,
  };
};
